import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const ProtectedRoute = ({ children, allowedRoles }) => {
    const { user, isAuthenticated, isLoading } = useContext(AuthContext);

    // Show loading spinner while checking authentication
    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <span className="ms-2">Checking authentication...</span>
            </div>
        );
    }

    // Redirect to login if not authenticated
    if (!isAuthenticated) {
        console.log('ProtectedRoute: Not authenticated, redirecting to login');
        return <Navigate to="/" replace />;
    }

    // Check user roles
    const userType = user?.userType?.toLowerCase() || '';

    if (allowedRoles && !allowedRoles.includes(userType)) {
        console.log('ProtectedRoute: Unauthorized access attempt', { userType, allowedRoles });
        return <Navigate to="/unauthorized" replace />;
    }

    console.log('ProtectedRoute: Access granted', { userType, allowedRoles });
    return children;
};

export default ProtectedRoute;
